import { Nullable } from "models/Nullable"

export function isEmpty<T>(value?: Nullable<T>): value is null | undefined {
    if (value === null || value === undefined || String(value).replaceAll(' ', '') === '') {
        return true
    }
    if (typeof value === 'object') {
        const objectIsNotEmpty = Object.values(value).some(val => !isEmpty(val))
        return !objectIsNotEmpty
    }
    if (Array.isArray(value)) {
        const arrayIsNotEmpty = value.some(val => !isEmpty(val))
        return !arrayIsNotEmpty
    }
    return false
}
